<template>
  <div>
    <b-row v-if="field.type == 19">
      <b-col class="mt-0">
        {{ field.label }}
      </b-col>
      <b-col cols="2">
        <a
          class="link"
          href="#"
          @click="downloadRoute(field.fieldId, item.processId)"
        >
          <i class="tim-icons icon-attach-87 route"> </i>
        </a>
      </b-col>
    </b-row>
    <b-row v-else-if="field.type == 1000">
      <b-col class="mt-0">
        <a class="link" href="#" @click="$refs.checklistDetails.open()">
          <u>#{{ itemValue }}</u>
        </a>
      </b-col>
      <pendency-field-details-modal ref="checklistDetails" :id="itemValue" />
    </b-row>
    <b-row v-else>
      <b-col class="mt-0 type-integration-script">
        {{ itemValue }}
      </b-col>
    </b-row>
  </div>
</template>
  
  <script>
export default {
  name: "WorkflowFilledListCell",
  components: {
    "pendency-field-details-modal": () =>
      import("@/pagesRms/checklist/pendency/PedencyFieldDetailsModal.vue"),
  },
  props: ["item", "field"],
  data: function () {
    return {
      urlChecklist: "",
      accessKey: "",
      urlCte: "",
      urlMap: "",
      alert: {
        error: "",
        success: "Registro alterado com sucesso",
      },
    };
  },
  computed: {
    itemName() {
      return this.field.label;
    },
    itemValue() {
      return this.item[this.field.key];
    },
    linkClass() {
      console.log("this.$store.getters.darkmode");
      console.log(this.$store.getters.darkmode);
      if (this.$store.getters.darkmode) return "link";
      return "link2";
    },
  },
  methods: {
    openNextStage() {
      this.$refs.kanbanEditModal.show();
    },
    refreshData() {
      this.$emit("refreshData");
    },
    downloadRoute(fieldId, processId) {
      this.$apiWorkflow
        .request({
          url: "/path/print/" + fieldId + "/" + processId,
          method: "POST",
          responseType: "arraybuffer", //important
        })
        .then((response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
  },
};
</script>
  
  
  <style>
.pre-formatted {
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
}
.route {
  color: white !important;
}

.link {
  text-decoration: underline;
  color: white !important;
}
.white-content .link {
  text-decoration: underline;
  color: rgba(34, 42, 66, 0.7) !important;
}
</style>